import { Experiment } from '@ms/yammer-data/dist/state/types';
import {
  useExperimentTreatmentWithoutReporting,
  useReportExperimentTreatmentCallback,
} from '@ms/yammer-hooks/dist/experiments';
import { useEffect } from 'react';

type UseReportVivaEngageAppTreatment = () => void;
export const useReportVivaEngageAppTreatment: UseReportVivaEngageAppTreatment = () => {
  const experimentTreatment = useExperimentTreatmentWithoutReporting(Experiment.VivaEngageAppUXMC);
  const isControlOrTreatment = experimentTreatment === 'control' || experimentTreatment === 'treatment';
  const reportExperimentTreatmentCallback = useReportExperimentTreatmentCallback(
    Experiment.VivaEngageAppUXMC,
    experimentTreatment
  );

  useEffect(() => {
    if (isControlOrTreatment) {
      reportExperimentTreatmentCallback();
    }
  }, [isControlOrTreatment, reportExperimentTreatmentCallback]);
};
